var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlags(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 38,
    viewBox: "0 0 51 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5557_42382)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.6758,
    y: 37.0889,
    width: 50,
    height: 37,
    rx: 5,
    transform: "rotate(-180 50.6758 37.0889)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.6758 37.0889L0.675777 37.0889L0.675778 17.3555L50.6758 17.3555L50.6758 37.0889Z",
    fill: "#F93939"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5557_42382"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.6758,
    y: 37.0889,
    width: 50,
    height: 37,
    rx: 5,
    transform: "rotate(-180 50.6758 37.0889)",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlags);
export default __webpack_public_path__ + "static/media/Flags.e53635aa324e78fa22adfb1c14e24121.svg";
export { ForwardRef as ReactComponent };